import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { thunkGoToGameGuidePage } from '../../redux/actions/gameGuideActions';
import { useAppDispatch } from '../../redux/store';
const POWER_PLAYER_FEATURE_MESSAGES = {
    themes: 'Customizing room themes requires being a Power Player.'
};
export const NeedsPowerPlayerMessageBoxContents = ({ onClose, powerPlayerFeatureMessageType }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        onClose();
        dispatch(thunkGoToGameGuidePage('power-player'));
    }, [onClose, dispatch]);
    return (_jsxs(_Fragment, { children: [_jsx(DialogContentText, { children: POWER_PLAYER_FEATURE_MESSAGES[powerPlayerFeatureMessageType] }), _jsx(DialogActions, { children: _jsx(Button, { color: 'secondary', variant: 'contained', onClick: onClick, children: "More Info" }) })] }));
};
